import { frontendURL } from '../../../../helper/URLHelper';

const checker = accountId => ({
  parentNav: 'checkerView',
  routes: ['checker_view', 'conversation_summaries'],
  menuItems: [
    {
      icon: 'chat',
      label: 'CHECKER_VIEW',
      key: 'checkerView',
      toState: frontendURL(`accounts/${accountId}/checker-view`),
      toolTip: 'Checker view for conversations',
      toStateName: 'checker_view',
    },
    {
      icon: 'document-text',
      label: 'CONVERSATION_SUMMARIES',
      key: 'conversationSummaries',
      toState: frontendURL(`accounts/${accountId}/conversation-summaries`),
      toolTip: 'View conversation summaries',
      toStateName: 'conversation_summaries',
    },
  ],
});

export default checker;
